module.exports = __webpack_public_path__ + "static/media/1006144.368819a8.png";